import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as galleryImageActions from '../../actions/gallery/galleryImageActions';
import {Link} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import PrivateAPIResource from "../../services/PrivateAPIResource";
import 'react-image-crop/dist/ReactCrop.css';

class GalleryImageRotatePage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            timestamp: (new Date()).getTime(),
            rotationAngle: 0
        };

        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];

        actions.push(this.props.actions.loadGalleryImage(
            this.props.match.params.galleryId,
            this.props.match.params.id
        ));
        return actions;
    }

    redirect() {
        this.context.router.history.push('/galleri/vis/' + this.props.match.params.galleryId);
    }

    rotateOriginalImage(rotationAngle) {
        this.setState({
            rotationAngle
        });
        let galleryId = this.props.galleryImage.galleryId;
        let imageId = this.props.galleryImage.id;
        PrivateAPIResource.put(`gallery/rotate-image/${galleryId}/${imageId}`, {
            rotationAngle: rotationAngle,
        }).then(() => {
            this.setState({
                rotationAngle: 0,
                timestamp: (new Date()).getTime()
            });
            toastr.success('Billede uploadet');
        }).catch(error => {
            console.log(error);
            toastr.error(error);
            // toastr.error('Kunne ikke uploade billedet');
        })
    }

    renderRotateButtons() {
        const defaultClass = 'btn btn-primary waves-effect waves-light clickable ml-3';

        if (this.state.rotationAngle == 90) {
            return (
                <span>
                    <button disabled className={`${defaultClass} disabled`}>
                        <i className="fa fa-spin fa-spinner"/> Arbejder...
                    </button>
                    <button disabled className={`${defaultClass} disabled`}>
                        <i className="fa fa-rotate-right"/> Rotate right
                    </button>
                </span>
            );
        } else if (this.state.rotationAngle == -90) {
            return (
                <span>
                    <button disabled className={`${defaultClass} disabled`}>
                        <i className="fa fa-rotate-left"/> Rotate left
                    </button>
                    <button disabled className={`${defaultClass} disabled`}>
                        <i className="fa fa-spin fa-spinner"/> Arbejder...
                    </button>
                </span>
            );
        } else {
            return (
                <span>
                    <button
                        onClick={this.rotateOriginalImage.bind(this, 90)}
                        className={`${defaultClass}`}
                    >
                        <i className="fa fa-rotate-left"/> Rotate left
                    </button>
                    <button
                        onClick={this.rotateOriginalImage.bind(this, -90)}
                        className={`${defaultClass}`}
                    >
                        <i className="fa fa-rotate-right"/> Rotate right
                    </button>
                </span>
            )

        }
    };

    render() {

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card m-b-20">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-12">
                                            <h1 className="m-b-30">Billede beskæring</h1>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <img alt="Rotate" style={{ maxWidth: "100%" }} src={this.props.galleryImage.filePath + `?${this.state.timestamp}`} />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-sm-12">
                                            {this.renderRotateButtons()}
                                            <Link
                                                to={`/galleri/vis/${this.props.match.params.galleryId}`}
                                                className="btn btn-secondary waves-effect ml-3"
                                            >
                                                Tilbage til galleriet
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WithResolvedPromises>
        )
    }
}

GalleryImageRotatePage.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {

    return {
        galleryImage: state.galleryImage,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...galleryImageActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleryImageRotatePage));




// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryImageRotatePage.jsx